module.exports = __webpack_public_path__ + "4601954f35041029432d96319f2958f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gqd-mn.png
// module id = 2008
// module chunks = 0